<template>
  <div class="red-packet1-dialog">
    <div class="red-packet1-content" slot="custom">
      <div v-if="data.couponDetailType === 'A'" class="red-packet1-title">
        <img src="../../images/hongbao_1_20.png" />
      </div>
      <div v-if="data.couponDetailType === 'B'" class="red-packet1-title">
        <img src="../../images/hongbao_1_100.png" />
      </div>
      <div class="red-packet1-items">
        <img src="../../images/pei_icon.png" />
        <div class="div">授信未通过我赔付</div>
      </div>
      <nd-button class="button" @click="handleButtonClick">
        立即领取额度
      </nd-button>
      <div class="activity-detail" @click="handleTextButtonClick">
        活动详情 >
      </div>
    </div>
  </div>
</template>
<script>
import { setKey } from '@/assets/utils'

export default {
  data () {
    return {
      visible: true
    }
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    visible (value) {
      this.$report({
        id: 10123,
        args: {
          visible: value ? 1 : 0,
          status: this.data.couponDetailType
        }
      })
    }
  },
  methods: {
    open () {
      this.visible = true
      setKey('RED_PACKET_1_SHOW_TIME', Date.now())
    },
    close () {
      this.visible = false
      this.$emit('close')
    },
    show () {
      setKey('RED_PACKET_1_SHOW_TIME', Date.now())
      this.$report({
        id: 10124,
        args: {
          target: 0,
          status: this.data.couponDetailType
        }
      })
    },
    handleButtonClick () {
      if (this.data.nextStep === 'INFO') {
        this.$report({
          id: 10124,
          args: {
            target: 1,
            status: this.data.couponDetailType
          }
        })
        this.$router.push('/authentication/base')
      }
      if (this.data.nextStep === 'OCR') {
        this.$report({
          id: 10124,
          args: {
            target: 1,
            status: this.data.couponDetailType
          }
        })
        this.$router.push('/authentication/id')
      }
      if (this.data.nextStep === 'CREDIT') {
        this.$report({
          id: 10124,
          args: {
            target: 1,
            status: this.data.couponDetailType
          }
        })
        this.$router.push('/authentication/base')
      }
      if (this.data.nextStep === 'CREDIT_REVIEW') {
        this.$router.push(
          `/authentication/result?applyNo=${this.data.relationId}`
        )
      }
    },
    handleTextButtonClick () {
      this.$report({
        id: 10124,
        args: {
          target: 3,
          status: this.data.couponDetailType
        }
      })
      this.$router.push({
        path: '/activities/compensation',
        query: {
          loanPlatform: 'TMD',
          activeType: this.data.activeType,
          open: 1
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.red-packet1-dialog {
    .red-packet1-content {
        width: 620px;
        height: 750px;
        border-radius: 30px;
        background-color: #5267c7;
        .red-packet1-title {
            display: inline-block;
            margin: 0px 0px;
            margin-top: 33px;
            margin-bottom: 36px;
            img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
            border: none;
        }
        }
        .red-packet1-items {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 440px;
            height: 140px;
            background: rgba(63, 69, 129, 1);
            border-radius: 20px;
            font-size: 30px;
            margin: 20px auto;
            color: #fff;
            img {
                width: 80px;
                height: 80px;
                margin-right: 24px;
            }
        }
        .button {
            margin: 44px auto;
            height: 88px;
            line-height: 88px;
            width: 500px;
            font-size: 36px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
            line-height: 50px;
        }
        .activity-detail {
            text-align: center;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            line-height: 40px;
            margin-bottom: 53px;
        }
    }
}
</style>
